import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { LoggerService } from "../logger/logger.service";

@Injectable()
export class StorageService {
  constructor(
    public storage: Storage,
    private logger: LoggerService,
  ) {
    this.storage.forEach((v, k, it) =>
      this.logger.log(`当前存储storage数据：key：${k}，value--`, "", it),
    );
  }

  /**
   *  获取用户相关ionicStoragevalue
   *  @param userid 用户id
   */
  async getUserStore(userid: string, key: string): Promise<any> {
    const newKey = userid + key;
    this.logger.log("storage---21", newKey);
    return this.getStore(newKey);
  }

  /**
   * 通过key value形式保存数据至ionicStorage
   * @param userid 用户id
   * @param key
   * @param value
   */
  async setUserStore(userid: string, key: string, value: any): Promise<any> {
    const newKey = userid + key;
    this.logger.log("storage---33", newKey);
    return this.setStore(newKey, value);
  }

  /**
   * 通过key获取ionicStoragevalue
   */
  async getStore(key: string): Promise<any> {
    if (!key) return null;
    const value = await this.storage.get(key);
    if (value && value != "undefined" && value != "null") {
      try {
        return JSON.parse(value);
      } catch (error) {
        return value;
      }
    }
    return null;
  }

  /**
   * 通过key value形式保存数据至ionicStorage
   * @param key
   * @param value
   */
  async setStore(key: string, value: any): Promise<any> {
    if (!key) return null;
    if (typeof value !== "string") {
      value = JSON.stringify(value);
    }
    return this.storage.set(key, value);
  }

  /**
   * 删除ionicStorage中指定key的value
   * @param key
   */
  async removeStore(key: string): Promise<any> {
    if (!key) return null;
    return this.storage.remove(key);
  }

  /**
   * 清除整个ionicStorage存储
   */
  async clearStore(): Promise<any> {
    return this.storage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/services/common/storage/storage.service.ts